import React from 'react';
import {
  FDBox,
  FDContentContainer,
  FDStack,
} from '@facet-wealth/design';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import StepNavigationFooter from 'Packages/FacetDesign/Components/Experimental/StepNavigationFooter';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { LottieLoadingLayout } from 'Components/ComponentLibrary/Organisms/LottieControl/LottieLoadingLayout';
import { dataAttrs } from 'Helpers/Testing';
import { TaxYearOptionsDropdown } from 'Views/Page/Content/Templates/TaxDiagnosticCommon/TaxYearOptionsDropdown';
import { TaxDiagnosticSummaries } from './TaxDiagnosticSummaries';

const Layout = () => {
  const [loading, setLoading] = React.useState(false);
  const { resource } = useMetaLayoutContext();
  const { loadPageContentLink, setPageContentCollection } = usePageContentContext();
  const { displayErrorMessage } = useSnackbarContext();

  useBoneBackgroundColor();

  const handleNext = async () => {
    try {
      setLoading(true);
      const nextStepColl = await resource.submit();
      setPageContentCollection(nextStepColl);
    } catch (err) {
      displayErrorMessage(err, err.errors);
    } finally {
      setLoading(false);
    }
  };

  const maybeHandlePrevious = resource.withRelationship(fr.relationships.previousLink.name,
    (rel) => () => loadPageContentLink(rel.link('related')),
    () => () => undefined);

  return (
    <LottieLoadingLayout>
      <FDContentContainer maxWidth="md">
        <FDStack direction="column" alignItems="stretch" spacing={4} paddingY={2}>
          <FDStack direction={'column'} alignItems={'center'} spacing={2}>
            <MetaControlField attr={'taxYearHeader'} />
            <TaxYearOptionsDropdown resource={resource} />
          </FDStack>
          <MetaControlField attr={'title'} {...dataAttrs('tax-diagnostic-summary-title')} />
          <MetaControlField attr={'description'} />
          {resource.attr('boostSavingsSections') ? <TaxDiagnosticSummaries
            title={resource.attr('boostSavingsTitle')}
            value={resource.attr('boostSavingsSections')}
            lottieRelationship={resource.relationship(fr.relationships.boostSavingsLottie.name)}
          /> : null}
          {resource.attr('keepMoreSections') ? <TaxDiagnosticSummaries
            title={resource.attr('keepMoreTitle')}
            value={resource.attr('keepMoreSections')}
            lottieRelationship={resource.relationship(fr.relationships.keepMoreLottie.name)}
          /> : null}
          {resource.attr('lowerTaxesSections') ? <TaxDiagnosticSummaries
            title={resource.attr('lowerTaxesTitle')}
            value={resource.attr('lowerTaxesSections')}
            lottieRelationship={resource.relationship(fr.relationships.lowerTaxesLottie.name)}
          /> : null}
          <FDStack direction="column" paddingY={4} justifyContent="center">
            <MetaControlField attr={'disclosure'} />
          </FDStack>
        </FDStack>
        <FDBox paddingY={4} />
      </FDContentContainer>
      <StepNavigationFooter
        isLoading={loading}
        onNext={handleNext}
        onPrevious={maybeHandlePrevious}
        label={resource.attr('primaryActionText')}
      />
    </LottieLoadingLayout>
  );
};

Layout.defaultProps = {
};

Layout.propTypes = {
};

export default Layout;
